export default "__VITE_ASSET__Enf0N3S4__"